import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../../../app/store';
import type { VerificationSliceState } from './state';

// ── Base selector ────────────────────────────────────────────────────
const selectSlice = (state: RootState): VerificationSliceState => state.verification;

// ── Core selectors ───────────────────────────────────────────────────
export const selectCurrentVerification = createSelector(selectSlice, (s) => s.current);
export const selectServerVerification = createSelector(selectSlice, (s) => s.server);

// ── Edit tracking ────────────────────────────────────────────────────
export const selectIsEdited = createSelector(selectSlice, (s) => s.isEdited);
export const selectEditedFields = createSelector(selectSlice, (s) => s.editedFields);
export const selectValidationErrors = createSelector(selectSlice, (s) => s.validationErrors);
